export type Deferred<T> = {
  promise: Promise<T>;
  resolve: (value: T) => void;
  reject: (reason: any) => void;
};

export const deferred = <T>(): Deferred<T> => {
  let resolver: (value: T) => void = () => {};
  let rejector: (reason: any) => void = () => {};

  return {
    promise: new Promise<T>((resolve, reject) => {
      resolver = resolve;
      rejector = reject;
    }),
    resolve: resolver,
    reject: rejector,
  };
};

export const zipWithKeys =
  <T>(keys: Array<string>) =>
  (values: Array<T>) =>
    keys.reduce((object: { [key: string]: T }, key: string, index: number) => {
      object[key] = values[index];
      return object;
    }, {});

export function awaitAllDeferredObjectValues<T>(deferredObjects: {
  [key: string]: Deferred<T> | T;
}) {
  const keys = Object.keys(deferredObjects);
  const values = Object.values(deferredObjects).map(
    value =>
      (typeof value === 'object' &&
      (value as Deferred<T>).hasOwnProperty('promise')
        ? (value as Deferred<T>).promise
        : Promise.resolve(value)) as Promise<T>,
  );
  return Promise.all(values).then(zipWithKeys<T>(keys));
}
